var _g, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackendLaravel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -8,
    y: -8,
    width: 86,
    height: 86
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4px)",
      clipPath: "url(#bgblur_0_50_578_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 16,
    transform: "matrix(-1 0 0 1 70 0)",
    fill: "#F49D0B",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 69,
    height: 69,
    rx: 15.5,
    transform: "matrix(-1 0 0 1 69 0)",
    stroke: "#F49D0B",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5159 26.7744V30.0647C46.5159 30.3673 46.2701 30.6131 45.9676 30.6131H35.5482V27.3228H34.4515V30.6131H24.0321C23.7296 30.6131 23.4837 30.3673 23.4837 30.0647V26.7744H22.387V30.0647C22.387 30.9719 23.1249 31.7099 24.0321 31.7099H34.4515V37.0588H35.5482V31.7099H45.9676C46.8747 31.7099 47.6127 30.972 47.6127 30.0648V26.7745H46.5159V26.7744Z",
    fill: "#EDF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7736 36.6452H34.357C34.0662 36.6452 33.7872 36.5296 33.5815 36.324L32.191 34.9335C31.8825 34.625 31.464 34.4517 31.0278 34.4517H26.2253C26.0331 34.4517 25.8485 34.4847 25.677 34.5452L25.0536 36.0968V49.8529C25.0536 50.7615 25.7902 51.4981 26.6987 51.4981H43.7737C44.6823 51.4981 45.4189 50.7615 45.4189 49.8529V38.2903C45.4188 37.3818 44.6822 36.6452 43.7736 36.6452Z",
    fill: "#FFE09F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6772 47.6129V34.545C25.0397 34.7717 24.5804 35.3815 24.5804 36.0968V50.3548C24.5804 51.2634 25.317 52 26.2256 52H43.774C44.4892 52 45.0917 51.5407 45.3184 50.9032H28.9675C27.1503 50.9032 25.6772 49.4301 25.6772 47.6129Z",
    fill: "#F6D190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0328 18H20.194C19.8911 18 19.6456 18.2455 19.6456 18.5484V26.7742C19.6456 27.0771 19.8911 27.3226 20.194 27.3226H26.2263C26.5292 27.3226 26.7747 27.0771 26.7747 26.7742V20.7419L24.7075 19.6602L24.0328 18Z",
    fill: "#ECEAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0316 23.4837H21.2897C20.9866 23.4837 20.7413 23.2384 20.7413 22.9353C20.7413 22.6322 20.9866 22.387 21.2897 22.387H24.0316C24.3348 22.387 24.58 22.6323 24.58 22.9353C24.58 23.2384 24.3347 23.4837 24.0316 23.4837Z",
    fill: "#6F6571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0316 25.6777H21.2897C20.9866 25.6777 20.7413 25.4324 20.7413 25.1293C20.7413 24.8262 20.9866 24.5809 21.2897 24.5809H24.0316C24.3348 24.5809 24.58 24.8262 24.58 25.1293C24.58 25.4324 24.3347 25.6777 24.0316 25.6777Z",
    fill: "#857E87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0001 32.2582C35.6058 32.2582 36.0969 31.7672 36.0969 31.1615C36.0969 30.5557 35.6058 30.0647 35.0001 30.0647C34.3944 30.0647 33.9033 30.5557 33.9033 31.1615C33.9033 31.7672 34.3944 32.2582 35.0001 32.2582Z",
    fill: "#B6B1B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1934 25.129V18H19.6451C19.3422 18 19.0967 18.2455 19.0967 18.5484V27.3226C19.0967 27.6255 19.3422 27.871 19.6451 27.871H26.2257C26.5286 27.871 26.7741 27.6255 26.7741 27.3226V26.7742H21.8386C20.93 26.7742 20.1934 26.0376 20.1934 25.129Z",
    fill: "#DAD8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0326 20.1935C24.0326 20.4963 24.2781 20.7419 24.581 20.7419H26.7745L24.0326 18V20.1935Z",
    fill: "#DAD8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4512 36.6451H35.5479V39.2168H34.4512V36.6451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0968 18H32.2581C31.9552 18 31.7097 18.2455 31.7097 18.5484V26.7742C31.7097 27.0771 31.9552 27.3226 32.2581 27.3226H38.2904C38.5933 27.3226 38.8388 27.0771 38.8388 26.7742V20.7419L36.7715 19.6602L36.0968 18Z",
    fill: "#ECEAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0968 23.4837H33.3549C33.0518 23.4837 32.8065 23.2384 32.8065 22.9353C32.8065 22.6322 33.0518 22.387 33.3549 22.387H36.0968C36.4 22.387 36.6452 22.6323 36.6452 22.9353C36.6452 23.2384 36.4 23.4837 36.0968 23.4837Z",
    fill: "#6F6571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0968 25.6777H33.3549C33.0518 25.6777 32.8065 25.4324 32.8065 25.1293C32.8065 24.8262 33.0518 24.5809 33.3549 24.5809H36.0968C36.4 24.5809 36.6452 24.8262 36.6452 25.1293C36.6452 25.4324 36.4 25.6777 36.0968 25.6777Z",
    fill: "#857E87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2586 25.129V18H31.7102C31.4074 18 31.1619 18.2455 31.1619 18.5484V27.3226C31.1619 27.6255 31.4074 27.871 31.7102 27.871H38.2909C38.5938 27.871 38.8393 27.6255 38.8393 27.3226V26.7742H33.9038C32.9951 26.7742 32.2586 26.0376 32.2586 25.129Z",
    fill: "#DAD8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0967 20.1935C36.0967 20.4963 36.3422 20.7419 36.6451 20.7419H38.8386L36.0967 18V20.1935Z",
    fill: "#DAD8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.161 18H44.3223C44.0194 18 43.7739 18.2455 43.7739 18.5484V26.7742C43.7739 27.0771 44.0194 27.3226 44.3223 27.3226H50.3546C50.6575 27.3226 50.903 27.0771 50.903 26.7742V20.7419L48.8357 19.6602L48.161 18Z",
    fill: "#ECEAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.162 23.4837H45.4201C45.1169 23.4837 44.8717 23.2384 44.8717 22.9353C44.8717 22.6322 45.117 22.387 45.4201 22.387H48.162C48.4651 22.387 48.7104 22.6323 48.7104 22.9353C48.7104 23.2384 48.4651 23.4837 48.162 23.4837Z",
    fill: "#6F6571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.162 25.6777H45.4201C45.1169 25.6777 44.8717 25.4324 44.8717 25.1293C44.8717 24.8262 45.117 24.5809 45.4201 24.5809H48.162C48.4651 24.5809 48.7104 24.8262 48.7104 25.1293C48.7104 25.4324 48.4651 25.6777 48.162 25.6777Z",
    fill: "#857E87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3228 25.129V18H43.7745C43.4716 18 43.2261 18.2455 43.2261 18.5484V27.3226C43.2261 27.6255 43.4716 27.871 43.7745 27.871H50.3551C50.658 27.871 50.9035 27.6255 50.9035 27.3226V26.7742H45.968C45.0594 26.7742 44.3228 26.0376 44.3228 25.129Z",
    fill: "#DAD8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1619 20.1935C48.1619 20.4963 48.4074 20.7419 48.7102 20.7419H50.9038L48.1619 18V20.1935Z",
    fill: "#DAD8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7943 50.875L49.5659 39.5604C49.6842 39.2053 49.4199 38.8386 49.0456 38.8386H30.1535C29.4454 38.8386 28.8167 39.2918 28.5928 39.9635L25.7755 48.4153L25.6367 50.705L26.2258 51.6014H44.2336C44.9318 51.6014 45.5527 51.5594 45.7846 50.9032C45.788 50.8938 45.7912 50.8844 45.7943 50.875Z",
    fill: "#ECBD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2262 49.8065H39.3875C39.0843 49.8065 38.8391 49.5612 38.8391 49.2581C38.8391 48.955 39.0844 48.7097 39.3875 48.7097H43.2262C43.5293 48.7097 43.7746 48.955 43.7746 49.2581C43.7746 49.5612 43.5293 49.8065 43.2262 49.8065Z",
    fill: "#F6D190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3229 47.6131H40.4842C40.181 47.6131 39.9358 47.3678 39.9358 47.0647C39.9358 46.7617 40.1811 46.5164 40.4842 46.5164H44.3229C44.626 46.5164 44.8712 46.7617 44.8712 47.0647C44.8712 47.3678 44.626 47.6131 44.3229 47.6131Z",
    fill: "#FFE09F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9682 50.9028C27.4256 50.9028 26.132 49.8476 25.776 48.415L24.8378 51.2295C25.1292 51.6909 25.6402 51.9996 26.2263 51.9996H44.234C44.9318 51.9996 45.5529 51.5584 45.785 50.9028H28.9682Z",
    fill: "#E2A975"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 59,
    r: 4,
    fill: "#F59E0B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_50_578_clip_path",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 16,
    transform: "matrix(-1 0 0 1 70 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackendLaravel);
export default __webpack_public_path__ + "static/media/backend-laravel.0c0e82216fa642d3d8e4825045ac12f6.svg";
export { ForwardRef as ReactComponent };